import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

import NotFoundImage from '../../assets/images/not-found.svg';

interface Iprops {
  leftSide?: boolean;
}
const NotFound = ({ leftSide }: Iprops): JSX.Element => {
  const { t } = useTranslation();
  return (
    <div
      className={`${
        leftSide ? 'h-full ' : 'h-screen '
      } w-full flex justify-center items-center text-center   `}
    >
      <div className="w-[336px] px-3 grid gap-4 text-neutral-40 justify-center self-center">
        <img className="m-2  px-3 flex  " src={NotFoundImage} alt="" />

        <h6 className="font-normal text-2xl">
          {t('not_found_page.page_not_found_message')}
        </h6>

        {leftSide ? null : (
          <NavLink
            to={{ pathname: '/' }}
            className="bg-[#D6E3FF] m-2 py-2 px-3 flex justify-center flex-row items-center border-none rounded-xl gap-2 no-underline hover:no-underline "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
            >
              <path
                d="M11.2327 20.2907C11.5326 20.5764 12.0074 20.5649 12.2931 20.2649C12.5787 19.965 12.5672 19.4903 12.2673 19.2046L6.01587 13.25L20.75 13.25C21.1642 13.25 21.5 12.9142 21.5 12.5C21.5 12.0858 21.1642 11.75 20.75 11.75L6.01577 11.75L12.2673 5.79526C12.5672 5.50958 12.5787 5.03484 12.2931 4.73492C12.0074 4.43499 11.5326 4.42345 11.2327 4.70913L3.81379 11.7758C3.64486 11.9367 3.54491 12.142 3.51393 12.3554C3.50479 12.4022 3.5 12.4505 3.5 12.5C3.5 12.5495 3.50481 12.598 3.51398 12.6449C3.54502 12.8581 3.64496 13.0632 3.81379 13.224L11.2327 20.2907Z"
                fill="#2277DB"
              />
            </svg>

            <span className="font-semibold text-base text-blue-00 ">
              {t('not_found_page.home_button')}
            </span>
          </NavLink>
        )}
      </div>
    </div>
  );
};
export default NotFound;
